import React from "react"

export const DownloadIcon = ({ size = 1, color = "#034055" }) => {
  return (
    <svg
      width={24 * size}
      height={24 * size}
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g fill="none" fillRule="evenodd">
        <path stroke={color} strokeWidth="2.5" d="M2.459 21H20.85" />
        <path
          fill={color}
          fillRule="nonzero"
          d="M13.375 13.264V1.75h-2.75v11.514H6.5L12 18.75l5.5-5.486z"
        />
      </g>
    </svg>
  )
}
